webpackJsonp([2,0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(64);
	
	var _vue = __webpack_require__(107);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(106);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  el: 'body',
	  components: { App: _App2.default }
	});

/***/ },

/***/ 61:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(47);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(63);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  deep: true,
	
	  createCropper: function createCropper(options) {
	    var _this = this;
	
	    options.crop = function (event) {
	      _this.vm.$emit('crop', event);
	    };
	    (0, _jquery2.default)(this.el).cropper('destroy');
	    setTimeout(function () {
	      (0, _jquery2.default)(_this.el).cropper(options);
	    });
	  },
	  bind: function bind() {
	    var _this2 = this;
	
	    this.vm.$on('rotate', function (deg) {
	      (0, _jquery2.default)(_this2.el).cropper('rotate', deg);
	    });
	  },
	  update: function update(options) {
	    this.createCropper(options);
	  },
	  unbind: function unbind() {
	    (0, _jquery2.default)(this.el).cropper('destroy');
	    this.vm.$off('rotate');
	  }
	};

/***/ },

/***/ 62:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Cropper = __webpack_require__(61);
	
	var _Cropper2 = _interopRequireDefault(_Cropper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  directives: {
	    Cropper: _Cropper2.default
	  },
	
	  data: function data() {
	    return {
	      cropData: {},
	      cropOptions: {
	        viewMode: 0,
	        zoomable: false
	      },
	      showCropper: false
	    };
	  },
	
	
	  events: {
	    crop: function crop(event) {
	      this.cropData = {
	        x: event.x,
	        y: event.y,
	        width: event.width,
	        height: event.height
	      };
	    }
	  },
	
	  methods: {
	    toggleCropper: function toggleCropper() {
	      this.showCropper = !this.showCropper;
	    }
	  }
	};

/***/ },

/***/ 64:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 65:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 104:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/mustache.9500140.jpg";

/***/ },

/***/ 105:
/***/ function(module, exports, __webpack_require__) {

	module.exports = " <div id=app> <h1>jQuery Cropper &amp; Vue Demonstration</h1> <button id=toggle @click=toggleCropper>Toggle Cropper</button> <div v-if=showCropper> <div id=options> <h3>Options</h3> <div id=view-modes> <button class=view-mode v-bind=\"{disabled: cropOptions.viewMode === 0}\" @click=\"cropOptions.viewMode = 0\"> View Mode 1 </button> <button class=view-mode v-bind=\"{disabled: cropOptions.viewMode === 1}\" @click=\"cropOptions.viewMode = 1\"> View Mode 2 </button> <button class=view-mode v-bind=\"{disabled: cropOptions.viewMode === 2}\" @click=\"cropOptions.viewMode = 2\"> View Mode 3 </button> <button class=view-mode v-bind=\"{disabled: cropOptions.viewMode === 3}\" @click=\"cropOptions.viewMode = 3\"> View Mode 4 </button> </div> <input type=checkbox v-model=cropOptions.zoomable> <label for=zoomable>Zoomable?</label> </div> <div id=actions> <h3>Actions</h3> <button @click=\"$emit('rotate', 90)\">Rotate 90°</button> </div> <img v-cropper=cropOptions src=" + __webpack_require__(104) + " alt=Mustache> <pre id=output>\nx: {{ cropData.x }}\ny: {{ cropData.y }}\nwidth: {{ cropData.width }}\nheight: {{ cropData.height }}\n      </pre> <div id=photo-credit> <a href=https://www.flickr.com/photos/gottshar/7077944259> Photo Credit </a> </div> </div> </div> ";

/***/ },

/***/ 106:
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(65)
	__vue_script__ = __webpack_require__(62)
	__vue_template__ = __webpack_require__(105)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ }

});


/** WEBPACK FOOTER **
 ** static/js/app.44fedc6e4349aa2429ca.js
 **/